import styled from "styled-components";

export const CloseImg = styled.img`
  width: 20px;
`;

export const ModalCloseBtn = styled.button`
  background-color: transparent;
  border: none;
`;

export const TitleText = styled.div`
  font-size: 25px;
  font-weight: 600;
  letter-spacing: .5px;
`;